import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Brand } from "../components/Brand";
import { CalendarDays, ClipboardList, Clock, User, Zap, LogOut } from "lucide-react";
import "../app-light.css";

const ITEMS = [
  { to: "", label: "Today", icon: Zap },
  { to: "schedule", label: "Schedule", icon: CalendarDays },
  { to: "jobs", label: "Jobs", icon: ClipboardList },
  { to: "time", label: "Time", icon: Clock },
  { to: "profile", label: "Profile", icon: User },
];

export function FieldShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="app-light min-h-screen bg-[#070B14] pb-24">
      <header className="sticky top-0 z-40 flex items-center justify-between border-b border-slate-800/80 bg-[#070B14]/95 px-4 py-3 backdrop-blur-xl">
        <Brand size={30} tone="light" />
        <button
          onClick={async () => { await logout(); navigate("/login"); }}
          aria-label="Log out"
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-700 text-slate-300"
          data-testid="logout-btn"
        >
          <LogOut size={18} />
        </button>
      </header>
      <main className="mx-auto max-w-xl px-4 py-5">
        <Outlet />
      </main>
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-800 bg-[#0B1120]/95 backdrop-blur-xl" data-testid="field-nav">
        <div className="mx-auto grid max-w-xl grid-cols-5">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={`/field/${it.to}`}
                end={it.to === ""}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 py-3 text-[11px] font-semibold transition-colors ${
                    isActive ? "text-cyan-400" : "text-slate-500"
                  }`
                }
                data-testid={`field-nav-${it.label.toLowerCase()}`}
              >
                <Icon size={22} />
                {it.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
